(function ($) {

    $(document).ready(function () {

        $('.details-block').each(function () {
            const $button = $(this).find('.open-details-button');
            const $content = $(this).find('.wrap-table');

            $button.on("click", function () {

                if ($(this).hasClass('open')) {
                    $content.slideUp(300);
                    $(this).removeClass('open');
                } else {
                    $content.slideDown(300);
                    $(this).addClass('open');
                }
            });
        });
    });

})(jQuery);